module.exports = __webpack_public_path__ + "img/pantalla_bloqueada.54779177.png";